import { render, staticRenderFns } from "./mcInboundAdd.vue?vue&type=template&id=c2701e86"
import script from "./mcInboundAdd.vue?vue&type=script&lang=js"
export * from "./mcInboundAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports